class StringUtil {
  public static isStringEmpty(str: string) {
    return str === "";
  }

  public static isStringNullOrEmpty(str: string) {
    return !str;
  }

  public static isNumber(obj: string) {
    return !isNaN(Number(obj));
  }

  public static parseStringWithOutWhitespace(obj: string) {
    return obj.replace(" ", "");
  }

  public static parseNumberWithMaxValue(obj: string, maxValue: number) {
    return Math.min(parseInt(obj), maxValue).toString();
  }

  public static parseNumberWithMinValue(obj: string, minValue: number) {
    return Math.max(parseInt(obj), minValue).toString();
  }

  public static removeNonNumeric(obj: string) {
    return obj.toString().replace(/\D/gi, "");
  }

  public static parseNumberWithComma(obj: any) {
    return obj == null || isNaN(obj) ? obj : obj.toLocaleString();
  }

  public static parseNumberWithCommaDecimal(obj: any) {
    if (obj == null || isNaN(obj)) {
      return obj;
    } else {
      const numberSplit = obj.toString().split(".");
      const integer = Number(numberSplit[0]);
      const decimal = numberSplit[1];
      if (Number(decimal) > 0) {
        return integer.toLocaleString() + "." + decimal;
      } else {
        return Number(obj).toLocaleString();
      }
    }
  }

  public static numberFormatter(e: any, decimalPoint?: number, isAbs: boolean = false) {
    if (e != null && !isNaN(e)) {
      let value = e;
      if (decimalPoint) {
        const s = Math.pow(10, decimalPoint);
        value = Math.round( value * s) / s;
      }
      return parseNumberWithCommaDecimal(isAbs ? Math.abs(value) : value);
    } else {
      return '0';
    }
  }

  public static hasDecimalPlace(e: any): boolean {
    if (e != null && !isNaN(e)) {
      const value = e.toString();
      return value.indexOf(".") > 0;
    } else {
      return false;
    }
  }

  public static joinStringArrayToString(obj: string[], joinString: string) {
    return obj.join(joinString);
  }

  public static getLocaleMonthName(month: number) {
    const objDate = new Date();
    objDate.setDate(1);
    objDate.setMonth(month - 1);
    return objDate.toLocaleString("default", { month: "long" });
  }

  public static roundWithComma(obj: string | number, roundDecimalPoint: number = 0) {
    if (obj && isNumber(obj.toString())) {
      return parseNumberWithCommaDecimal(StringUtil.round(obj, roundDecimalPoint));
    } else {
      return obj;
    }
  }

  public static round(obj: any, roundDecimalPoint: number = 0) {
    if (obj && isNumber(obj.toString())) {
      let target = Number(obj.toString());

      if (roundDecimalPoint === 0) {
        return Math.round(target);
      } else {
        let s = Math.pow(10, roundDecimalPoint);
        return Math.round(target * s) / s;
      }
    } else {
      return obj;
    }
  }

  public static formatBusinessNo(value: string): string {
    const digits = value.replace(/\D/g, '').slice(0, 10);
    if (digits.length <= 3) return digits;
    if (digits.length <= 5) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
  }

  public static stringNumberToNumeric(value: string): number | undefined {
    const onlyNumber = value.replace(/[^0-9]/g, '');
    if (!/^[0-9]*$/.test(onlyNumber)) {
      return undefined;
    }
    return Number(onlyNumber);
  }
}

export const {
  isStringEmpty,
  isStringNullOrEmpty,
  isNumber,
  parseStringWithOutWhitespace,
  parseNumberWithMaxValue,
  parseNumberWithMinValue,
  removeNonNumeric,
  parseNumberWithComma,
  parseNumberWithCommaDecimal,
  numberFormatter,
  hasDecimalPlace,
  joinStringArrayToString,
  getLocaleMonthName,
  roundWithComma,
  round,
  stringNumberToNumeric,
  formatBusinessNo
} = StringUtil;
